export function extractYouTubeVideoId(value) {
  const raw = String(value || "").trim();
  if (!raw) return "";

  let parsed;
  try {
    parsed = new URL(/^https?:\/\//i.test(raw) ? raw : `https://${raw}`);
  } catch {
    return "";
  }

  const host = parsed.hostname.toLowerCase().replace(/^www\./, "");
  let videoId = "";
  if (host === "youtube.com" || host === "m.youtube.com") {
    const parts = parsed.pathname.split("/").filter(Boolean);
    if (parts[0] === "shorts" || parts[0] === "embed") videoId = parts[1] || "";
    else if (parsed.pathname === "/watch") videoId = parsed.searchParams.get("v") || "";
  } else if (host === "youtu.be") {
    videoId = parsed.pathname.split("/").filter(Boolean)[0] || "";
  }

  return videoId && /^[A-Za-z0-9_-]{6,}$/.test(videoId) ? videoId : "";
}

export function normalizeEventVideoUrl(value) {
  const raw = String(value || "").trim();
  if (!raw) return "";

  let parsed;
  try {
    parsed = new URL(/^https?:\/\//i.test(raw) ? raw : `https://${raw}`);
  } catch {
    return "";
  }

  const videoId = extractYouTubeVideoId(parsed.href);
  if (videoId) return `https://www.youtube.com/watch?v=${videoId}`;
  return parsed.href;
}
